import {apiRequest, vtrRequest} from "../actions/api";
import { LOGIN , VTR_TRIP_REQUEST} from "../actions/actionTypes";
import {baseServerUrl} from '../constants/default_request';

export const appMiddleware = () => next => action => {
    next(action);
    if (action.type === LOGIN) {
            next(
                apiRequest({
                    url: baseServerUrl + '/base_api/',
                    method: 'post',
                    data: action.payload,
                    username: action.username,
                    password:action.password
                })
            );
        }
    if(action.type === VTR_TRIP_REQUEST){
        next(
            vtrRequest({
                url: baseServerUrl + "/base_api/vtr_docid",
                method: 'post',
                client_id:action.client_id,
                token:action.token,
                user_app_status:action.user_app_status,
                trip_id:action.trip_id
            })
        );
    }
};
